var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_vm._t("activator",function(){return [_c('v-btn',_vm._b({staticClass:"upper-case white--text",attrs:{"id":_vm.ElementUID,"large":"","block":"","color":"baColorVibrantBlue","type":"button"}},'v-btn',_vm.$attrs,false),[_vm._v(" Register Now ")])]},{"ElementUID":_vm.ElementUID})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }